<template>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog')" @keydown.esc="$emit('updateDialog')" width="750">
        <v-card>
            <v-card-title class="title-modal">
                <span class="headline">{{ title }}</span>
            </v-card-title>

            <v-card-text>
                <p>
                    Seleccione el muelle al que desea asignar a la ola.
                </p>
                <v-form ref="form">
                    <v-combobox v-model="almacen" name="name" item-title="name" item-value="id" :items="almacenes"
                        label="Almacen*" autocomplete="off" :rules="[rules.requiredComboBox]" clearable
                        @update:modelValue="
                        () => {
                            this.loadMuelles();                          
                        }
                        "
                    ></v-combobox>
                    <v-combobox v-model="item.dock" name="name" item-title="name" item-value="id" :items="muelles"
                        label="Muelle*" autocomplete="off" :rules="[rules.requiredComboBox]" clearable :disabled="!almacen"></v-combobox>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="$emit('updateDialog')"> Cancelar </v-btn>
                <v-btn color="green" text @click="assign()" :loading="loading"> {{button_accept}} </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { muelleService } from "@/libs/ws/muelleService";
import { almacenService } from "@/libs/ws/almacenService";
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
    created() { },
    mixins: [ValidMixin],
    components: {},
    props: {
        dialog: Boolean,
        updateDialog: Function,
        assignMuelle: Function,
        loading: Boolean,
        title: String,
        button_accept: String
    },
    data: () => ({
        item: {
            dock: null,            
        },
        defaultItem: null,
        muelles: [],
        almacenes: [],
        almacen: null
    }),
    watch: {

    },
    mounted() {
        this.defaultItem = JSON.parse(JSON.stringify(this.item));
        this.almacen = JSON.parse(localStorage.getItem("almacen"));
        this.loadMuelles();
        this.loadAlmacenes();
    },
    methods: {
        loadAlmacenes() {
            almacenService
                .filter({})
                .then((response) => {
                // console.log("almacenes",response);
                this.almacenes = response.result.list;
                })
                .catch((e) => {
                console.log("service.load error");
                console.log(e);
                });
        },
        loadMuelles() {
            this.loading_muelles = true;

            const params = { 
                almacen: this.almacen
            }

            muelleService
                .filter(params)
                .then((response) => {
                    this.muelles = response.result.list;
                })
                .catch((e) => {
                    console.log("service.load error");
                    console.log(e);
                })
                .finally(() => {
                    this.loading_muelles = false;
                });
        },
        async assign() {
            const { valid } = await this.$refs.form.validate();
            if (valid) {
                this.$emit("assignMuelle", this.item.dock);
            }
        },
    },
};
</script>